import { html, LitEntity } from '../../utility/lit-entity';
import './fas-integration-modal';
import { IntegrationOverviewMixin } from './integration-overview-mixin';

class FasIntegrationOverview extends IntegrationOverviewMixin(LitEntity) {
  render() {
    return this.renderOverview();
  }

  renderModal() {
    return html`
      <fas-integration-modal
        title="${this.title}"
        .href="${this.href}"
        ?hide="${!this.showModal}"
        @close="${() => this.showModal = false}"
      ></fas-integration-modal>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.integrationEnabled = this.entity.properties.credentialsConfigured;
  }
}

window.customElements.define('fas-integration-overview', FasIntegrationOverview);
